import DepsService from 'services/dependencies';

const CONTEXT = 'forgotPassword';

export const fetchSecurityQuestions = async () => {
  const { url } = DepsService.rest.security.questions;
  const queryParams = { };
  const urlParams = { locale: '*' };
  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams );
};





// WEBPACK FOOTER //
// ./src/modules/security/resources/security.api.js